import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useServiceItems } from '../hooks/useServiceItems';
import './ServicesPage.css';

const ServicesPage: React.FC = () => {
  const { t } = useLanguage();
  const items = useServiceItems();

  return (
    <section className="services-page editorial-section">
      <div className="editorial-container">
        <header className="services-page-header">
          <h1 className="section-heading">{t.services.page.title}</h1>
          <p className="section-intro">{t.services.page.intro}</p>
        </header>

      <div className="services-list">
        {items.map((service) => (
          <Link
            key={service.slug}
            to={`/services/${service.slug}`}
            className="services-list-item editorial-list-item"
          >
            <div className="services-list-content">
              <h2 className="editorial-list-title">{service.title}</h2>
              <p className="editorial-list-meta">{service.meta}</p>
              <p className="editorial-list-body">{service.tagline}</p>
            </div>
            <ArrowUpRight className="services-list-arrow" size={28} aria-hidden="true" />
          </Link>
        ))}
      </div>
    </div>
    </section>
  );
};

export default ServicesPage;
